// extracted by mini-css-extract-plugin
export default {"sort":"FilterData_sort__1C-ZC"};